/**
 * Increment the current date value by the parameter field
 * Returns an ISO8601 formatted string
 * @param years
 * @param months
 * @param days
 * @param hours
 * @param minutes
 */
export const incrementDate = (
    years?: number,
    months?: number,
    days?: number,
    hours?: number,
    minutes?: number,
): string => {
    const dt = new Date();
    if (years) {
        dt.setFullYear(dt.getFullYear() + years);
    }
    if (months) {
        dt.setMonth(dt.getMonth() + months);
    }
    if (days) {
        dt.setDate(dt.getDate() + days);
    }
    if (hours) {
        dt.setHours(dt.getHours() + hours);
    }
    if (minutes) {
        dt.setMinutes(dt.getMinutes() + minutes);
    }
    return dt.toISOString();
};
